import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

@connect((store) => {
    return { };
})
class NoFpact extends React.Component {
    constructor(props) {
        super(props);
        this.goToKaiserInfo = this.goToKaiserInfo.bind(this);
        this.goToClinicList = this.goToClinicList.bind(this);
        this.goToPharmacyList = this.goToPharmacyList.bind(this);
    }

    // componentWillMount() {
    //     document.body.style.alignItems = 'baseline';
    // }

    // componentWillUnmount() {
    //     document.body.style.alignItems = 'center';
    // }

    goToKaiserInfo() {
        this.props.history.push('/location?id=kaiser')
    }

    goToClinicList() {
        this.props.history.push('/clinics');
    }

    goToPharmacyList() {
        this.props.history.push('/pharmacylist');
    }

    render() {
        return (
            <div>
                <img className="has-fpact-image" src="./images/noFpact.png"/>
                <h1 className="ec__font__title text-center">You have a few options</h1>
                <div className="card-container">
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Local Kaiser Permanente
                            </p>
                            <p className="card__text">
                                $0 - $25
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToKaiserInfo}>See details</a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                A clinic (drop-in available)
                            </p>
                            <p className="card__text">
                                $0 - $20
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToClinicList}>See list</a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Local pharmacies
                            </p>
                            <p className="card__text">
                                $0 - $25
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToPharmacyList}>See list</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NoFpact;



// WEBPACK FOOTER //
// ./src/components/screens/NoFpact.js